import Box from '@paperstac/ui/lib/Box';
import React from 'react';

const Section = React.memo((props) => <Box py={4} {...props} />);

Section.propTypes = {};

Section.defaultProps = {};

Section.displayName = 'Section';

export default Section;
